// extracted by mini-css-extract-plugin
module.exports = {"search-bar-container":"search-bar-container-Vb_fz","search-input":"search-input-BWyeG","icon":"icon-poa62"};